<template>
  <div>
    <section
      class="section-title-page container-fluid"
      style="background-image: url('/img/bg_tramite.jpg')"
    >
      <div class="container">
        <div class="wrapper">
          <h1>
            Galeria <small style="font-weight: 300"> de actividades</small>
          </h1>
          <span>
            Volver <i class="fa fa-angle-right mx-1"></i>
            <a href="/">Inicio</a>
          </span>
        </div>
      </div>
    </section>
    <section class="section-galeria container-fluid">
      <div class="container p-0">
        <div class="col p-0 d-flex flex-wrap" v-if="events.length > 0">
          <div class="col-md-6" v-for="(event, index) in events" :key="index">
            <div class="box">
              <div
                class="image"
                :style="{ backgroundImage: 'url(' + event.imagen + ')' }"
              ></div>
              <div class="text">
                <h3>{{ event.titulo }}</h3>
                <h6>
                  Fecha: <strong>{{ event.fecha }}</strong>
                </h6>
                <button
                  class="btn mt-2 bg-brown text-white"
                  @click="openGallery(event.galeria)"
                >
                  Ver galería
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col p-0 d-flex flex-wrap" v-else>
          <div class="section-info w-100">
            <p class="m-0">
              <i class="fa-solid fa-ban mr-2"></i><strong>Lo sentimos</strong>,
              hoy no hay ningún evento institucional registrado.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Modal para la Galería -->
    <div v-if="isGalleryOpen" class="modal" @click.self="isGalleryOpen = false">
      <div class="modal-content">
        <span class="close" @click="isGalleryOpen = false">&times;</span>
        <div class="carousel">
          <img :src="currentImages[currentIndex]" class="gallery-image" />
          <div class="carousel-controls">
            <button @click="prevImage" :disabled="currentIndex === 0">
              <i class="fa fa-angle-left"></i>
            </button>
            <button
              @click="nextImage"
              :disabled="currentIndex === currentImages.length - 1"
            >
              <i class="fa fa-angle-right"></i>
            </button>
          </div>
          <div class="image-counter">
            {{ currentIndex + 1 }} / {{ currentImages.length }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "galeria",
  computed: {
    ...mapState(["empresa"]),
  },
  mounted() {
    this.getGaleria();
  },
  data() {
    return {
      isGalleryOpen: false,
      currentImages: [],
      currentIndex: 0,
      events: {},
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),
    getGaleria() {
      this.setLoading(true);
      this.$http.get("ws_main/galery").then((res) => {
        this.events = res.data.Galeria;
        this.setLoading(false);
      });
    },
    openGallery(galeria) {
      this.currentImages = galeria.map((item) => item.imagen);
      this.currentIndex = 0;
      this.isGalleryOpen = true;
    },
    nextImage() {
      if (this.currentIndex < this.currentImages.length - 1) {
        this.currentIndex++;
      }
    },
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
  },
};
</script>

<style>
.modal {
  display: flex;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  justify-content: center;
  align-items: center;
}

.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  overflow: auto;
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}

.close {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 30px;
  cursor: pointer;
}

.carousel {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.gallery-image {
  max-width: 100%;
  max-height: 400px;
  margin: 10px;
  border-radius: 5px;
}

.carousel-controls {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.carousel-controls button {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.carousel-controls button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.image-counter {
  margin-top: 10px;
  font-size: 16px;
}
</style>